export enum CommentType {
  DISPATCHER = "DISPATCHER",
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  LINE11 = "LINE11"
}